import { axiosRequest } from '../api';
import { API_PATH } from '../../constants';

export const PatientService = {
  getPatientsList(params){ return axiosRequest('GET', API_PATH.PATIENT.LIST(params)) },
  getPatient(data){ return axiosRequest('POST', API_PATH.PATIENT.INFO, data) },
  addPatient(data){ return axiosRequest('POST', API_PATH.PATIENT.SAVE, data) },
  patientAdmission(data){ return axiosRequest('POST', API_PATH.PATIENT.ADMISSION, data) },
}